<template>
  <div class="custom-actions">
    <button class="ui basic button icon-wrapper"
            @click="upSort()">
      <i class="icon">
        <img :src="arrow" class="icon"/>
      </i>
    </button>
    <button class="ui basic button icon-wrapper"
            @click="downSort()">
      <i class="icon">
        <img :src="arrow" class="icon reverse"/>
      </i>
    </button>
  </div>
</template>

<script>
import arrow from '@/assets/icons/arrow.svg';

export default {
  name: 'CurationAction',
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async upSort() {
      await this.$store.dispatch('orderUp', this.rowData.order_index);
      this.$table.updateField();
    },
    async downSort() {
      await this.$store.dispatch('orderDown', this.rowData.order_index);
      this.$table.updateField();
    },
  },
  data() {
    return {
      arrow,
    };
  },
};
</script>

<style lang="scss" scoped>
.custom-actions {
  width: 100px;
  height: auto;

  margin-top: 10px;

  .icon-wrapper {
    padding: 10px;

    .icon {
      margin-left: 4px;

      width: 10px;
      height: 10px;
    }

    .reverse {
      transform: rotateZ(180deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/curation/detail-row/CurationAction.vue